import React from 'react'
import createMarkup from './common/createMarkup'
import heroStyles from 'styles/hero.module.scss'

function Headline({ content }) {
  return (
    <h1
      className={heroStyles.headline}
      dangerouslySetInnerHTML={createMarkup(content)}
    />
  )
}

export default Headline
